(function(){
var hash = window.location.hash;
let tab = document.querySelector('#system-tabs a[href="' + hash.replace('#!','') + '"]');
tab && (new bootstrap.Tab(tab)).show();
const searchInput = document.getElementById('configuration-search');
if (searchInput) {
const headerElement = document.getElementById('header-system-configuration');
const searchContainer = searchInput.closest('.col-md-6');
function resetElementsVisibility() {
document.querySelectorAll('#system-tabs .tab-content li').forEach(item => {
item.style.display = '';
});
document.querySelectorAll('#system-tabs .tab-content ul').forEach(ul => {
ul.style.display = '';
});
document.querySelectorAll('#system-tabs .tab-content h5').forEach(header => {
header.style.display = '';
});
document.querySelectorAll('#system-tabs .tab-content div').forEach(header => {
header.style.display = '';
});
}
function restoreTabFunctionality() {
const tabPanes = document.querySelectorAll('#system-tabs .tab-content .tab-pane');
tabPanes.forEach(pane => {
pane.classList.remove('active');
pane.classList.remove('show');
});
const activeTabLink = document.querySelector('#system-tabs .nav-tabs .nav-link.active');
if (activeTabLink) {
const activeTabId = activeTabLink.getAttribute('href');
if (activeTabId) {
const activePane = document.querySelector(activeTabId);
if (activePane) {
activePane.classList.add('active');
activePane.classList.add('show');
} else {
document.querySelector('#system-tabs .tab-pane:first-child').classList.add('active');
document.querySelector('#system-tabs .tab-pane:first-child').classList.add('show');
}
}
} else {
document.querySelector('#system-tabs .tab-pane:first-child').classList.add('active');
document.querySelector('#system-tabs .tab-pane:first-child').classList.add('show');
}
document.querySelector('#system-tabs .nav-tabs').style.display = '';
}
function resetColumnVisibility() {
document.querySelectorAll('#system-tabs .tab-content .col-md-6, #system-tabs .tab-content .col-md-12').forEach(column => {
column.style.display = '';
if (column.classList.contains('col-md-12')) {
column.classList.remove('col-md-12');
column.classList.add('col-md-6');
}
});
}
function manageSearchContainerSize(expand) {
if (searchContainer) {
if (expand) {
searchContainer.classList.remove('col-md-6');
searchContainer.classList.add('col-md-12');
} else {
searchContainer.classList.remove('col-md-12');
searchContainer.classList.add('col-md-6');
}
}
}
searchInput.addEventListener('focus', function() {
if (headerElement) {
headerElement.style.display = 'none';
}
manageSearchContainerSize(true);
});
searchInput.addEventListener('keydown', function(e) {
if (e.key === 'Escape') {
this.blur();
}
});
searchInput.addEventListener('blur', function() {
if (this.value.toLowerCase().trim() === '' && headerElement) {
headerElement.style.display = '';
}
manageSearchContainerSize(this.value.toLowerCase().trim() !== '');
});
searchInput.addEventListener('input', function() {
const searchTerm = this.value.toLowerCase().trim();
const configLinks = document.querySelectorAll('#system-tabs .tab-content a');
const configListItems = document.querySelectorAll('#system-tabs .tab-content li');
const tabPanes = document.querySelectorAll('#system-tabs .tab-content .tab-pane');
resetElementsVisibility();
resetColumnVisibility();
if (searchTerm !== '') {
tabPanes.forEach(pane => {
pane.classList.add('active');
pane.classList.add('show');
});
document.querySelector('#system-tabs .nav-tabs').style.display = 'none';
const matchingHeadings = [];
document.querySelectorAll('#system-tabs .tab-content h5').forEach(header => {
const headerText = header.textContent.toLowerCase();
if (headerText.includes(searchTerm)) {
matchingHeadings.push(header);
}
});
matchingHeadings.forEach(header => {
const nextUl = header.nextElementSibling;
if (nextUl && nextUl.tagName === 'UL') {
const items = nextUl.querySelectorAll('li');
items.forEach(item => {
item.style.display = '';
});
}
});
configLinks.forEach(link => {
const linkText = link.textContent.toLowerCase();
const listItem = link.closest('li');
if (listItem) {
let underMatchingHeading = false;
for (const header of matchingHeadings) {
const nextUl = header.nextElementSibling;
if (nextUl && nextUl.contains(listItem)) {
underMatchingHeading = true;
break;
}
}
if (!underMatchingHeading) {
if (linkText.includes(searchTerm)) {
listItem.style.display = '';
} else {
listItem.style.display = 'none';
}
}
}
});
document.querySelectorAll('#system-tabs .tab-content h5').forEach(header => {
if (matchingHeadings.includes(header)) {
header.style.display = '';
return;
}
const nextUl = header.nextElementSibling;
if (nextUl && nextUl.tagName === 'UL') {
const visibleItems = nextUl.querySelectorAll('li:not([style*="display: none"])').length;
if (visibleItems > 0) {
header.style.display = '';
nextUl.style.display = '';
} else {
header.style.display = 'none';
nextUl.style.display = 'none';
}
}
});
document.querySelectorAll('#system-tabs .tab-content .col-md-6').forEach(column => {
const visibleItems = column.querySelectorAll('li:not([style*="display: none"])').length;
if (visibleItems > 0) {
column.style.display = '';
column.classList.remove('col-md-6');
column.classList.add('col-md-12');
} else {
column.style.display = 'none';
}
});
} else {
restoreTabFunctionality();
resetElementsVisibility();
}
});
}
})();
